var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"color":_vm.locationSet ? 'primary' : null},on:{"click":_vm.setLocation}},[_vm._v(_vm._s(_vm.locationSet ? "mdi-crosshairs-gps" : "mdi-crosshairs"))])}
var staticRenderFns = []

export { render, staticRenderFns }